import { useState } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { useAuth } from '@/hooks/useAuth'
import { ErrorBoundary } from '@/components/ErrorBoundary'

export function MainLayout() {
  const { isLoading, isAuthenticated, isNetworkError } = useAuth()
  const location = useLocation()
  const [sidebarHidden, setSidebarHidden] = useState(false)

  // In development, allow access even if backend is unavailable
  const isDev = import.meta.env.DEV

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Show warning banner if backend is unavailable but allow viewing in dev mode
  if (isNetworkError && isDev) {
    return (
      <div className="flex flex-col h-screen overflow-hidden">
        <Sidebar hidden={sidebarHidden} onToggleHidden={() => setSidebarHidden(h => !h)} />
        <main className="flex-1 overflow-y-auto">
          <div className="bg-yellow-500/20 border-b border-yellow-500/30 px-4 py-2 text-sm text-yellow-300">
            ⚠️ Backend unavailable at 127.0.0.1:9090. Run FastAPI to enable full functionality.
          </div>
          <ErrorBoundary resetKey={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    )
  }

  // Redirect to login if not authenticated (and not in dev mode with network error)
  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />
  }

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <Sidebar hidden={sidebarHidden} onToggleHidden={() => setSidebarHidden(h => !h)} />
      <main className="flex-1 overflow-y-auto">
        <ErrorBoundary resetKey={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}
